import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from './defaultIconStyles.css';

type Props = IconProps & React.SVGProps<SVGSVGElement>;
export const IconMonitoring = ({
    width = 20,
    height = 20,
    className,
    ...rest
}: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 2C2.34315 2 1 3.34315 1 5V15C1 16.6569 2.34315 18 4 18H16C17.6569 18 19 16.6569 19 15V5C19 3.34315 17.6569 2 16 2H4ZM3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5V15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15V5ZM11.9537 12.1461L15.7632 7.64612L14.2368 6.35388L11.0152 10.1594L8.74603 8.57935L8.01431 8.06984L7.42457 8.7386L4.24997 12.3386L5.75003 13.6614L8.3349 10.7302L10.619 12.3207L11.3658 12.8406L11.9537 12.1461Z"
            />
        </svg>
    );
};

export default IconMonitoring;
